import React from "react";
import { Box, Typography} from "@mui/material";
import ParaData from "src/Component/content-component/ParaData";
import ContentContainer from "src/Component/grid-component/ContentContainer";
import MainContainer from "src/Component/grid-component/MainContainer";

const imageBaseUrl = process.env.REACT_APP_IMAGE_URL

const mbbsImg2 = imageBaseUrl + "mbbsabroad.png";

const WhyStudyMbbsAbroad = () => {
  return (
    <>
      <MainContainer
        dir="row"
        color={"#EFFDFF"}
        com1={
          <ContentContainer
            Header={
              <Typography
              variant="h2"
              gutterBottom
              sx={{
                color: "#00999E",
                fontSize: "36px",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: { xs: "40px", sm: "42px", md: "48px", lg: "55px" },
                textTransform: "capitalize",
                paddingTop: { xs: "40px", sm: "0px", md: "0px", lg: "0px" },
              }}
            >
              ~Ready to Begin Your Journey? ~
            </Typography>
            }
            Content={
              <ParaData
                color={"#525560"}
                fontSize={"16px"}
                content={
                  "We’re more than just education consultants — as premier study abroad consultants in Kolkata, we’re your partners in shaping a successful future. We offer expert guidance in global education, fostering cross-cultural understanding and lifelong opportunities. From arts to medicine, our team supports your academic and personal growth. Choose TAKSHEELA for excellence, reliability, and tailored service in Kolkata. Ready for an international education? Contact us today for a free consultation and explore the opportunities waiting for you!"
                }
              />
            }
            
           
          />
        }
        com2={
          <Box
            sx={{
              width: "100%",
              borderRadius: "10px",
              overflow: "hidden",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img src={mbbsImg2} alt="Study Abroad Consultants in Kolkata" width="85%" height="85%" />
          </Box>
        }
      />
    </>
  );
};
export default WhyStudyMbbsAbroad;
